/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'company-hub.carousel-extension.card-strip.card.label': 'diapositive {positionInSet} sur {setSize}',
  'company-hub.carousel-extension.carousel-content.extra-small-frame.placeholder-title': 'Ajoutez un titre',
  'company-hub.carousel-extension.carousel-navigation.pause': 'Interrompre',
  'company-hub.carousel-extension.carousel-navigation.play': 'Lancer',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.next': 'Suivant',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.previous': 'Précédent',
  'company-hub.carousel-extension.config-panel.add-frame-cta': 'Ajouter un cadre',
  'company-hub.carousel-extension.config-panel.field.frames.error.invalid-list': 'Ajoutez des cadres',
  'company-hub.carousel-extension.config-panel.layout.title': 'Choisir une disposition',
  'company-hub.carousel-extension.config-panel.layouts.frame-above-image.label': "Texte encadré superposé sur l'image",
  'company-hub.carousel-extension.config-panel.layouts.solid-color-background.label': 'Arrière-plan uni',
  'company-hub.carousel-extension.config-panel.layouts.split-design-content.label': 'Fractionner le design',
  'company-hub.carousel-extension.config-panel.link.field.label': 'Lien',
  'company-hub.carousel-extension.config-panel.lozenge.label.updated': 'MISE À JOUR',
  'company-hub.carousel-extension.config-panel.navigation.progress-circles': "Cercles d'avancement",
  'company-hub.carousel-extension.config-panel.navigation.thumbnails': 'Miniatures',
  'company-hub.carousel-extension.config-panel.preamble-link.label-v2': 'En savoir plus sur les carrousels',
  'company-hub.carousel-extension.config-panel.preamble-v2':
    "Concevez un ensemble pouvant aller jusqu'à {number} cadres rotatifs. {supportLink}",
  'company-hub.carousel-extension.config-panel.preamble-v2-without-support-link':
    "Concevez un ensemble pouvant aller jusqu'à {number} cadres rotatifs.",
  'company-hub.carousel-extension.config-panel.style.general.title': 'Général',
  'company-hub.carousel-extension.config-panel.style.navigation.title': 'Navigation',
  'company-hub.carousel-extension.config-panel.styles.autoplay-label': 'Lecture automatique',
  'company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content':
    "Configurez votre carrousel pour qu'il défile automatiquement toutes les {number} secondes en mode d'affichage",
  'company-hub.carousel-extension.config-panel.tab.content.label': 'Contenu',
  'company-hub.carousel-extension.config-panel.tab.styles.label': 'Styles',
  'company-hub.carousel-extension.config-panel.title': 'Carrousel',
  'company-hub.carousel-extension.description.field.label': 'Description',
  'company-hub.carousel-extension.description.placeholder': 'Personnalisez ce cadre pour créer un carrousel rotatif.',
  'company-hub.carousel-extension.frame-spotlight.label': 'cadre {positionInSet} sur {setSize}',
  'company-hub.carousel-extension.frame.background.color': "Couleur d'arrière-plan",
  'company-hub.carousel-extension.frame.color-contrast.fail':
    'Les couleurs de votre texte et de votre arrière-plan ne sont pas optimales pour la lisibilité.',
  'company-hub.carousel-extension.frame.color-contrast.success':
    'Les couleurs de votre texte et de votre arrière-plan sont optimales pour la lisibilité.',
  'company-hub.carousel-extension.frame.text.color': 'Couleur du texte',
  'company-hub.carousel-extension.hub-element.description': 'Un ensemble rotatif de magnifiques cadres',
  'company-hub.carousel-extension.hub-element.title': 'Carrousel',
  'company-hub.carousel-extension.manifest.macro-description': 'Créez un trio de cadres dynamiques en rotation.',
  'company-hub.carousel-extension.manifest.macro-title': 'Carrousel',
  'company-hub.carousel-extension.manifest.macro-title.updated': 'Carrousel [Mis à jour]',
  'company-hub.carousel-extension.placeholder.description': 'Personnalisez ce cadre pour créer un carrousel rotatif.',
  'company-hub.carousel-extension.placeholder.title': 'Donnez un titre à votre cadre',
  'company-hub.carousel-extension.recommended.field.label': '(Recommandé)',
  'company-hub.carousel-extension.title.field.label': 'Titre',
  'company-hub.carousel-extension.title.placeholder': 'Donnez un titre à votre cadre',
};
